var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkEarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Dollar-Increase--Streamline-Flex",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Dollar Increase Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dollar-increase--dollar-increase-arrow-up-fluctuate-investment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.414 3.238v-0.533",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.414 8.032V7.5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3176",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.808 4.249c0 -0.547 -0.45 -1.012 -1.394 -1.012 -0.945 0 -1.394 0.438 -1.394 1.012 0 0.447 0.45 0.877 1.394 1.012 0.945 0.135 1.607 0.446 1.607 1.12 0 0.608 -0.662 1.117 -1.607 1.117s-1.607 -0.434 -1.607 -1.012",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.09 6.794c0.094 -0.437 0.142 -0.913 0.142 -1.426 0 -3.087 -1.736 -4.824 -4.823 -4.824C2.322 0.544 0.585 2.281 0.585 5.368c0 2.336 0.995 3.898 2.817 4.52",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3175",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.027 13.456s2.359 -3.117 3.405 -3.032c0.84 0.068 0.915 1.854 1.694 1.532 0.52 -0.215 3.484 -2.904 4.213 -3.57",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.846 8.163c0.776 -0.194 1.784 -0.116 2.52 0.195 0.194 0.775 0.116 1.783 -0.194 2.52",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkEarning);
export default __webpack_public_path__ + "static/media/dark-earning.6a1ad7cb923ec87f4b7efc1ec6cab1b1.svg";
export { ForwardRef as ReactComponent };